export default "__VITE_ASSET__CKt3QFsw__"